"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _UserInfo = _interopRequireDefault(require("@rsuite/icon-font/lib/people/UserInfo"));

// Generated by script, don't edit it please.
var UserInfo = (0, _createSvgIcon["default"])({
  as: _UserInfo["default"],
  ariaLabel: 'user info',
  category: 'people',
  displayName: 'UserInfo'
});
var _default = UserInfo;
exports["default"] = _default;
module.exports = exports.default;